import React, { useEffect, useState } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { useRouteMatch, useLocation } from 'react-router-dom';
import { getProject, processPageTabsVar, queryID } from '../views/common/utils';
import KmapTree from '../views/KmapTree/KmapTree';
import { treeStore, openTabStore } from '../hooks/useCloseStore';
import $ from 'jquery';
import { useKmap } from '../hooks/useKmap';
import { SearchBoxAndButtons } from '../search/SearchBoxAndButtons';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';
import { ArrayOfObjectsParam } from '../hooks/utils';
import { TermsParser } from '../views/Terms/TermsParser';

const TreeNav = (props) => {
    const openTab = openTabStore((state) => state.openTab);
    const tree = treeStore((state) => state.tree);
    const setTree = treeStore((state) => state.setTree);
    const [currSel, setCurrSel] = useState(0);
    let openclass = openTab === 2 ? 'open' : 'closed';
    const loc = useLocation();
    let termsPerspective = 'tib.alpha';
    if (loc.pathname.includes('glossary/nod')) {
        termsPerspective = 'new.alpha';
    }
    // console.log('terms pers', termsPerspective);

    let domain = 'places';

    const location = useLocation();

    const match = useRouteMatch([
        '/:baseType/:id/related-:type/:definitionID/view/:relID',
        '/:baseType/:id/related-:type/:definitionID/:viewMode',
        '/:baseType/:id/related-:type',
        '/:baseType/:id',
    ]);

    // eslint-disable-next-line no-unused-vars
    const [query, setQuery] = useQueryParams({
        searchText: StringParam,
        filters: withDefault(ArrayOfObjectsParam, []),
    });

    let { searchText: search, filters: qfilters } = query;

    // Load Current node to send down to trees

    const qid = queryID(match?.params?.baseType, match?.params?.id);
    const {
        isLoading: isKmapLoading,
        data: kmapData,
        isError: isKmapError,
        error: kmapError,
    } = useKmap(qid, 'info');

    // Get function to handle closeButton state.
    //const handleCloseButton = closeStore((state) => state.changeButtonState);

    const changeTab = openTabStore((state) => state.changeButtonState);

    // On page load
    useEffect(() => {
        // When embedded in WP
        if (process.env.REACT_APP_STANDALONE === 'standalone') {
            // On page load set active tab based on any matched domain in location path of standalone
            const path_parts = window.location.pathname.split('/');
            const matches = ['places', 'subjects', 'terms'].filter((val) =>
                path_parts.includes(val)
            );
            if (matches.length > 0) {
                setTree(matches[0]);
            }
        } // End of Standalone (WP) test
    }, []);

    useEffect(() => {
        setCurrSel(kmapData);
    }, [kmapData]);

    /*
    useEffect(() => {
        if (match) {
            let cs = match.params.id * 1;
            setCurrSel(cs);
        }
    }, [match]);
     */

    // Whenever the React location changes, update the tab based on any domain in the React Route
    useEffect(() => {
        // Look for Domain in React Route
        if (match?.params?.baseType) {
            domain = match.params.baseType;
            if (['places', 'subjects', 'terms'].includes(domain)) {
                setTree(domain);
            }
        }
    }, [location]);

    const handleCloseButton = () => {
        changeTab(0);
        $('.bottom-deck').hide();
    };

    const showClearAll = search || qfilters?.length > 0;

    return (
        <aside
            id="l-column__search--treeNav"
            className={`l-column__search real-asisde c-TreeNav--tabs ${openclass}`}
        >
            <div>
                <span
                    className={
                        'sacrifical-dummy-element-that-is-not-displayed-for-some-reason'
                    }
                ></span>
                <header className="treeNav-header">
                    <h4 className="treeNav-header__title">Browse</h4>
                    <button
                        onClick={handleCloseButton}
                        className="treeNav-header__closeButton"
                    >
                        <span className={'icon shanticon-cancel'}></span>
                    </button>
                </header>
                <SearchBoxAndButtons
                    eid="sui-search-trees"
                    showSearchBar={true}
                    showClearAll={showClearAll}
                />
                <Tabs
                    // defaultActiveKey={domain}
                    activeKey={tree}
                    onSelect={(k) => {
                        setTree(k);
                    }}
                    id="kmaps-tab"
                    role="navigation"
                    className="treeNav-tabs__wrap justify-content-center"
                >
                    <Tab eventKey="places" title="Places">
                        <KmapTree
                            elid="tab-tree-places"
                            domain="places"
                            level={1}
                            isOpen={true}
                            project={getProject()}
                            selData={currSel}
                        />
                    </Tab>
                    <Tab eventKey="subjects" title="Subjects">
                        <KmapTree
                            elid="tab-tree-subjects"
                            domain="subjects"
                            level={1}
                            project={getProject()}
                            selData={currSel}
                        />
                    </Tab>
                    <Tab eventKey="terms" title="Terms">
                        <KmapTermsTabs
                            project={getProject()}
                            selDat={currSel}
                            perspective={termsPerspective}
                        />
                    </Tab>
                </Tabs>
            </div>
        </aside>
    );
};

function KmapTermsTabs({ project, selDat, perspective }) {
    const [tab, setTab] = useState('tree');

    const selectMe = () => setTab('parser');

    return (
        <Tabs
            // defaultActiveKey={domain}
            activeKey={tab}
            onSelect={(k) => {
                setTab(k);
            }}
            id="terms-tabs"
            role="navigation"
            className="treeNav-tabs__wrap justify-content-center"
        >
            <Tab eventKey="tree" title="Tree">
                <KmapTree
                    elid="tab-tree-terms"
                    domain="terms"
                    level={1}
                    project={project}
                    selData={selDat}
                    perspective={perspective}
                />
            </Tab>
            <Tab eventKey="parser" title="Parser">
                <TermsParser selectMe={selectMe} />
            </Tab>
        </Tabs>
    );
}

export default TreeNav;
